import { render, staticRenderFns } from "./QuestionnaireAnswers.vue?vue&type=template&id=5ad2346d&scoped=true"
import script from "./QuestionnaireAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionnaireAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad2346d",
  null
  
)

export default component.exports